module.exports = __webpack_public_path__ + "img/34.bb1b70aa.jpg";